import api from './api';

/**
 * Subscription Service
 * Handles all subscription-related API calls
 */
const subscriptionService = {
  /**
   * Activate demo subscription for current user
   * @returns {Promise<Object>} Subscription data
   */
  activateDemo: async () => {
    const response = await api.post('/subscriptions/demo', {});
    return response.data;
  },

  /**
   * Get current subscription status
   * @returns {Promise<Object>} Subscription status data
   */
  getStatus: async () => {
    const response = await api.get('/subscriptions/status');
    // Return the full response data including is_expired flag
    // This allows us to detect expired subscriptions even when has_subscription is false
    if (response.data.subscription) {
      return {
        ...response.data.subscription,
        days_remaining: response.data.days_remaining,
        is_expired: response.data.is_expired,
        has_subscription: response.data.has_subscription
      };
    }
    // If no subscription but is_expired is true, return expired status
    if (response.data.is_expired) {
      return {
        status: 'expired',
        is_expired: true,
        has_subscription: false,
        days_remaining: 0
      };
    }
    return null;
  },

  /**
   * Get subscription history
   * @returns {Promise<Array>} Array of subscription records
   */
  getHistory: async () => {
    const response = await api.get('/subscriptions/history');
    return response.data;
  },

  /**
   * Cancel current subscription
   * @returns {Promise<Object>} Cancellation confirmation
   */
  cancel: async () => {
    const response = await api.delete('/subscriptions/cancel');
    return response.data;
  },

  /**
   * Create Stripe checkout session for subscription purchase
   * @param {Object} checkoutData - Checkout session data
   * @returns {Promise<Object>} Checkout session with URL
   */
  createCheckoutSession: async (checkoutData) => {
    const response = await api.post('/payments/create-checkout', checkoutData);
    return response.data;
  },
};

export default subscriptionService;
